import React from "react";
import { Link } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";
import { XCircle, ArrowLeft, RefreshCcw } from "lucide-react";
import { motion } from "framer-motion";

const RegisterCancelled = () => {
    const { t, i18n } = useTranslation();

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full space-y-8">
                <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.5 }}
                    className="bg-white p-8 rounded-3xl shadow-xl text-center"
                >
                    <div className="mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-red-100 mb-6">
                        <XCircle className="h-10 w-10 text-red-600" />
                    </div>

                    <h1 className="text-3xl font-extrabold text-gray-900 mb-2">
                        {t("register_cancelled.title", "Registration Cancelled")}
                    </h1>

                    <p className="text-gray-500 mb-8">
                        {t("register_cancelled.message", "You have cancelled the registration process.")}
                    </p>

                    <div className="space-y-4">
                        <Link
                            to={`/${i18n.language}/register?type=office`}
                            className="w-full flex items-center justify-center gap-2 px-8 py-3 border border-transparent text-base font-medium rounded-xl text-white bg-gray-900 hover:bg-black md:py-4 md:text-lg transition-colors shadow-lg"
                        >
                            <RefreshCcw className="w-5 h-5" />
                            {t("register_cancelled.buttons.try_again", "Try Again")}
                        </Link>

                        <Link
                            to={`/${i18n.language}`}
                            className="w-full flex items-center justify-center gap-2 px-8 py-3 text-base font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-xl md:py-4 md:text-lg transition-colors"
                        >
                            <ArrowLeft className="w-5 h-5" />
                            {t("register_cancelled.buttons.return_home", "Return Home")}
                        </Link>
                    </div>

                    <p className="mt-8 text-xs text-gray-400">
                        <Trans
                            i18nKey="register_cancelled.support_text"
                            defaults="If you experienced an issue, please contact <0>support</0>."
                            components={[<a href={`/${i18n.language}/contact`} className="text-blue-600 hover:underline">support</a>]}
                        />
                    </p>
                </motion.div>
            </div>
        </div>
    );
};

export default RegisterCancelled;
